<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col md="4">
        <div>
          <div @click="trigger" v-if="!loading">
            <div class="card" style="margin-bottom: unset !important;">
              <div class="card-body p-0 d-flex align-items-center text-center">
                <i class="cui-cloud-upload bg-primary p-4 font-2xl">
                  <br />
                  <span class="text-white small font-system">Clique para adicionar uma imagem</span>
                </i>
              </div>
            </div>
            <input
              @change="onFileInputChanged"
              ref="fileInput"
              style="display: none;"
              type="file"
              accept="image/*"
            />
          </div>
          <div v-if="loading">
            <div class="card" style="width: 242px; height: 122px; margin-bottom: unset !important;">
              <div class="card-body p-0 d-flex align-items-center text-center">
                <spinner id="loadingDiv" v-if="loading"></spinner>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "./../service";
import Multiselect from "vue-multiselect";
import Spinner from "./Spinner";
import Config from "../config";

export default {
  name: "ImportDesign",
  data() {
    return {
      loaded: false,
      selectedCategories: [],
      taggingSelected: null,
      categoriesList: [],
      categoriesList: [],
      temporaryDesign: undefined,
      random: Math.random(),
      loading: false,
      isCreating: false
    };
  },
  methods: {
    onFileInputChanged(event) {
      this.uploadFiles(event.target.files);
    },
    trigger() {
      this.$refs.fileInput.click();
    },
    uploadFiles(files) {
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );

      reader.readAsDataURL(files[0]);
      this.loading = true;

      var formData = new FormData();
      formData.append("file", files[0]);

      const baseURL = Config.BASE_API_URL;

      var vm = this;
      fetch(baseURL + "upload-express-template", {
        headers: {
          "Conectados-Auth": localStorage.sessionId
        },
        method: "POST",
        body: formData,
        bypassInterceptor: true
      }).then((response) => {
        if (response && response.status && response.status === 200) {
          response.json().then(jsonResponse => {
            vm.$emit("uploadComplete");
            vm.imagePreview = "";
            vm.loading = false;
            this.$router.push("/design/save/" + jsonResponse.temporaryId);
          });
        } else {
        }
      });
    }
  },
  created: function() {
   
  },
  components: { Multiselect, Spinner }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
</style>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
